import { defineComponent, defineAsyncComponent } from 'vue';
import App from './app.class';
import { setupComponent } from '@studyportals/vue-platform';

export default defineComponent({
	props: {
		viewType: {
			type: String,
			required: true,
		},
	},
	components: {
		ProfileView: defineAsyncComponent(() => import('./components/Views/Profile/ProfileView.vue')),
		JourneyView: defineAsyncComponent(() => import('./components/Views/Journey/JourneyView.vue')),
	},
	setup: () => {
		const component = new App();

		return setupComponent(component);
	},
});
